// extracted by mini-css-extract-plugin
export default {"colors":"ib3WEGW0ntEokcCZbXEI","wrapper":"bhpaY1p77wSQAu5X0toY","disabled":"ILifB1aXg7QHPsaoL6_l"};